
import TouchFeedback from './src/TouchFeedback'
export default TouchFeedback



// WEBPACK FOOTER //
// ./components/vc-m-feedback/index.js